import { action } from 'satcheljs';
import type ServicesRequestStatus from '../store/schema/ServicesRequestStatus';

/**
 * Action to update current GetMeetingTypeExtension request status.
 */
const setGetMeetingTypeExtensionRequestStatus = action(
    'SET_GET_MTE_STATE',
    (getMeetingTypeExtensionRequestStatus: ServicesRequestStatus) => ({
        getMeetingTypeExtensionRequestStatus,
    })
);

export default setGetMeetingTypeExtensionRequestStatus;
